module.exports = __webpack_public_path__ + "img/prodolz-1.75a0f6ad.png";